import { render, staticRenderFns } from "./arrayType.vue?vue&type=template&id=437e6b9c&scoped=true&"
import script from "./arrayType.vue?vue&type=script&lang=js&"
export * from "./arrayType.vue?vue&type=script&lang=js&"
import style0 from "./arrayType.vue?vue&type=style&index=0&id=437e6b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e6b9c",
  null
  
)

export default component.exports